/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { UnitDependencies } from './dependenciesUnitClass.generated';
import { createQuantumOfCirculation } from '../../factoriesAny.js';
export var quantumOfCirculationDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  UnitDependencies: UnitDependencies,
  createQuantumOfCirculation: createQuantumOfCirculation
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesQuantumOfCirculation.generated.js
// module id = 1624
// module chunks = 0